import React from 'react';
import { IExtra } from '../../../../domain/ancillary/domain/models/IExtra';
import { BookingSummarySection } from './BookingSummarySection';
import { ExtraVariantSummary } from './ExtraVariantSummary';

interface IExtraSummaryProps {
	extra: IExtra;
}

export const ExtraSummary = ({ extra }: IExtraSummaryProps) => {
	if (!extra.variants?.length) {
		return null;
	}

	return (
		<BookingSummarySection title={extra.name}>
			{extra.variants.map((variant) => (
				<ExtraVariantSummary key={variant.id} variant={variant} />
			))}
		</BookingSummarySection>
	);
};
